var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-0 shadow"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"animate__animated animate__fadeIn",staticStyle:{"height":"600px","overflow-y":"auto","overflow-x":"hidden"}},[_c('Page',{attrs:{"titulo":"Plano de Atendimento Familiar - PAF","mode":"table"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }